import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { LoginCallback } from "@okta/okta-react";

import Login from "./Views/Login";
import Dashboard from "./Views/Dashboard";
import Explore from "./Views/Explore";
import What from "./Views/WhatTodo";
import Guides from "./Views/Guides";
import Documentation from "./Views/Documentation";
import Test from "./Views/Test";
import Casestudies from "./Views/Casestudies";
import ProductUpdates from "./Views/ProductUpdates";
import LoginOkta from "./okta/LoginOkta";
import LoadingOkta from "./okta/LoadingOkta";
import { RequiredAuth } from "./okta/SecureRoute";
import Admin from "./Views/Admin/index";

const AppRouter = () => {
  return (
    <Routes>
      {/* Ruta pública para el inicio de sesión con Okta */}
      <Route path="/" element={<LoginOkta />} />

      {/* Manejar el callback de inicio de sesión de Okta */}
      <Route
        path="login/callback"
        element={<LoginCallback loadingElement={<LoadingOkta />} />}
      />

      {/* Rutas protegidas que requieren autenticación */}
      <Route element={<RequiredAuth />}>
        <Route path="/home" element={<Dashboard />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/what" element={<What />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/documentation" element={<Documentation />} />
        <Route path="/casestudies" element={<Casestudies />} />
        <Route path="/productupdates" element={<ProductUpdates />} />
        <Route path="/test" element={<Test />} />
      </Route>

      {/* Redirigir cualquier ruta desconocida a la página de inicio de sesión */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRouter;
